const firebaseConfig = {
  apiKey: "AIzaSyAMU068QpQvRrLHCSfZtG402AIBnPaxZlg",
  authDomain: "login-form-6274e.firebaseapp.com",
  projectId: "login-form-6274e",
  storageBucket: "login-form-6274e.appspot.com",
  messagingSenderId: "514758836403",
  appId: "1:514758836403:web:d3a1c80f08e5999c65b0c6",
};

export default firebaseConfig;
